// Images
// Styled
import { BasicLayout, Description, Hide } from "../styles";
import styled from "styled-components";
// React dom router
// Framer Motion
import { motion } from "framer-motion";
import { aboutAnim, fade } from "../animation";
// Wave
import Wave from "./Wave";

const ResponsiveText = styled(motion.p)`
  max-width: 50%;

  @media (max-width: 1300px) {
    max-width: 70%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    text-align: center;
  }
`;

const AboutSection = () => {
  return (
    <BasicLayout>
      <Description>
        <motion.div>
          <Hide>
            <motion.h2 variants={aboutAnim}>Hello, I'm </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={aboutAnim}>
              <span>Mohammad Asif Azimi</span>
            </motion.h2>
          </Hide>
        </motion.div>
        <ResponsiveText variants={fade}>
          An aspiring data analyst. I work with Python, SQL, and Tableau to
          clean data, build dashboards, and uncover insights. I'm passionate
          about storytelling with data and eager to grow as an intern.
        </ResponsiveText>
        <a href="/cv.pdf" target="_blank" rel="noopener noreferrer">
          <motion.button variants={fade}>Download CV</motion.button>
        </a>
      </Description>
      <Wave />
    </BasicLayout>
  );
};

export default AboutSection;
